<template>
  <div class="inner2 inner6 inner8">
    <home v-if="showInfo" />
  </div>
</template>

<script>
import { hex_md5 } from "@/common/js/md5.js";
import fun from "@/common/js/common";
import { loginFcmFum } from "@/common/js/fcm";
import home from "./view8/home";

export default {
  name: "inner",
  inject: ["reload"],
  provide() {
    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
    return {
      innerToService: this.innerToService,
    };
  },
  components: {
    home,
  },

  data() {
    return {
      ref:"user",
      isOldReg: "",
      heartTime: 900,
      index: "0",
      os: "", //设备类型
      brand: "", //设备品牌
      systemversion: "", // 版本
      adid: "", // 广告id
      idfa:"",//idfa
      userInfo: "", //用户信息
      wechatCode: "", // 微信code
      wxurl: "", //访问路径
      deskIcon: false, // 是否是桌面ICON进入
      ipAdress: "", //ip
      model: "",
      wxappid: "", //微信appid
      wechatType: false,
      gameId: "", //gameId 游戏id
      showInfo: "",
    };
  },
  watch: {},
  created() {},
  mounted() {
    var that = this;
    this.ref = localStorage.getItem("ref");
    //用户信息
    this.userInfo = localStorage.getItem("userInfo")
      ? JSON.parse(localStorage.getItem("userInfo"))
      : {};

    // this.isOldReg =  localStorage.getItem("isOldReg");
    // if (this.userInfo.uid) {
    //   if(this.isOldReg== null|| this.isOldReg==''|| this.isOldReg=='null'||this.isOldReg==undefined || this.isOldReg!=this.adid){
    //     localStorage.removeItem("userInfo");
    //     this.reload();
    //   }
    // }

    this.adid = localStorage.getItem("adid")
      ? localStorage.getItem("adid")
      : fun.getQueryString("adid");
    //链接和缓存中都没有则默认空字符串
    if(localStorage.getItem("idfa")){
      this.idfa = localStorage.getItem("idfa")
    }else if(fun.getQueryString("idfa")){
      this.idfa = fun.getQueryString("idfa")
    };
    //实名防沉迷检测
    this.fcmTesting();
    this.getShowInfo();
    //获取设备信息
    var MobileDetect = require("mobile-detect");
    var md = new MobileDetect(window.navigator.userAgent);
    this.brand = md.mobile();
    this.os = md.os() === "iOS" ? "ios" : "android";
    //idfa为空时，os则沿用上面的三目赋值，md.os不是ios则赋值android
    if(this.idfa){
      this.os = "ios";
    }
    //判断uuid是否存在，是否需要获取

    var deviceData = {
      uid: this.userInfo.uid ? this.userInfo.uid : "",
      idfa:this.idfa,
      uuid: localStorage.getItem("uuid")
        ? localStorage.getItem("uuid")
        : this.genUUID(),
      os: this.os,
      brand: this.brand,
      isEmulator: false,
    };
    localStorage.setItem("idfa",this.idfa);

    this.$store.commit("postDeviceData", deviceData);
    var wxurl = escape(window.location.href);
    localStorage.setItem("wxurl", wxurl);

    this.verticitionToken();
    if (!localStorage.getItem("uuid")) {
      this.sendDeviceInfo();
    }

    var isweixin = this.isWeixn();
    this.$store.commit("postWechatType", isweixin);
    this.checkedBrowserType();

    // this.wechatCode = localStorage.getItem("code")
    //   ? localStorage.getItem("code")
    //   : fun.getQueryString("code");
    this.wechatCode = localStorage.getItem(this.wxappid)
      ? localStorage.getItem(this.wxappid)
      : fun.getQueryString("code");
    // 是否是微信内
    this.wechatType = this.isWeixn();

    console.log(this.wechatCode + "--------");
    window.setInterval(() => {
      setTimeout(() => {
        that.heartbeat();
      }, 0);
    }, this.heartTime * 1000); //heartTime单位秒
  },
  watch: {
    wxappid() {
      if (this.wechatType) {
        this.wechatCode = fun.getQueryString("code");
        // 微信内支付
        console.log("微信内");
        if (
          this.wechatCode == null ||
          this.wechatCode == "" ||
          this.wechatCode == "undefined" ||
          this.wechatCode == undefined
        ) {
          console.log("获取code");
          this.getWxCode();
        } else {
          localStorage.setItem(this.wxappid, this.wechatCode);
        }
      }
    },
  },
  methods: {
    //实名防沉迷检测
    fcmTesting() {
      if (localStorage.getItem("userInfo")) {
        var loginStatus = loginFcmFum(
          this.userInfo.loginFcm,
          this.userInfo.fcm,
          this.userInfo.age
        );
        if (loginStatus == "0") {
          if (this.index == "0") {
            this.index = "1";
            let _this = this;
            this.$store.dispatch("IsTipsFun", true);
        // 应该是这里了
            setTimeout(function () {
              _this.$store.dispatch("IsTipsFun", false);
              _this.$store.dispatch("IsReconiseInfoFun", true);
                // 这里已经判断过了呀 loginFcmFum这个方法判断的
            }, 1000);
          }
        }
        if (loginStatus == "2") {
          this.$toast.text("未成年人玩家不可登录游戏");
          setTimeout(function () {
            localStorage.removeItem("userInfo");
            _this.reload();
          }, 2000);
        }
      }
    },
    //获取uuid的方法
    genUUID() {
      let random =
        Math.floor(
          (Math.random() + Math.floor(Math.random() * 9 + 1)) *
            Math.pow(10, 4 - 1)
        ) + "";
      let time = new Date().getTime() + "";
      return this.adid + "H5" + time + "" + random;
    },

    // 判断是否在微信内
    isWeixn() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    },
    // 获取微信code
    getWeixinCode(wechatCode) {
      let data = {
        code: wechatCode,
        gameId: this.gameId,
      };
      this.$http
        .post(
          fun.apiPayUrl + "paycenter/pay/saveWxCodeAndCacheThisOpenId",
          data
        )
        .then(
          function (res) {},
          function (res) {}
        );
    },
    getWxCode() {
      this.wxurl = escape(window.location.href);
      //获取code
      this.wechatCode = fun.getQueryString("code");
      console.log(this.wechatCode);
      if (
        this.wechatCode != null &&
        this.wechatCode != "" &&
        this.wechatCode != "undefined" &&
        this.wechatCode != undefined
      ) {
        this.getWeixinCode(this.wechatCode);
        localStorage.setItem(this.wxappid, fun.getQueryString("code"));
      }
      this.wechatCode = localStorage.getItem(this.wxappid);
      if (
        this.wechatCode == null ||
        this.wechatCode == "" ||
        this.wechatCode == "undefined" ||
        (this.wechatCode == undefined && this.wxappid)
      ) {
        let redirect_uri = escape(window.location.href);
        window.location.href =
          "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
          this.wxappid +
          "&redirect_uri=" +
          redirect_uri +
          "&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect";
      }
    },
    getShowInfo() {
      let data = {
        adid: this.adid,
      };
      this.$http
        .post(fun.apiUrl + "api/common/sdk/init?adid=" + this.adid, data)
        .then(
          function (res) {
            if (
              res.data.data.heartTime != undefined &&
              res.data.data.heartTime != "" &&
              res.data.data.heartTime != null &&
              res.data.data.heartTime != "null"
            ) {
              this.heartTime = res.data.data.heartTime;
            }
            if (res.data.data.wxAppId) {
              this.wxappid = res.data.data.wxAppId;
              localStorage.setItem("wxappid", this.wxappid);
              this.gameId = res.data.data.gameId;
              localStorage.setItem("gameId", this.gameId);
            }
            this.showInfo = res.data.data;
            localStorage.setItem("showInfo", JSON.stringify(res.data.data));
          },
          function (res) {}
        );
    },

    heartbeat() {
      //用户信息
      this.userInfo = localStorage.getItem("userInfo")
        ? JSON.parse(localStorage.getItem("userInfo"))
        : {};

      if (!this.userInfo.uid) {
        return false;
      }
      var time = new Date().getTime();
      var device_params = this.$store.state.deviceData;
      let data = {
        adid: this.adid,
        device_params: device_params,
        os: device_params.os,
        time: time,
        uid: this.userInfo.uid,
        token: this.userInfo.token,
      };
      let _this = this;
      this.$http
        .post(fun.apiUrl + "api/member/heartbeat", data)
        .then(function (res) {
          if (res.body.code === 200) {
            if (res.body.data != undefined) {
              _this.userInfo.age = res.body.data.age;
              _this.userInfo.fcm = res.body.data.fcm;
              _this.userInfo.loginFcm = res.body.data.loginFcm;
              _this.userInfo.payFcm = res.body.data.payFcm;
              localStorage.setItem("userInfo", JSON.stringify(this.userInfo));
              //实名防沉迷检测
              this.fcmTesting();
            }
          } else if (res.body.code === 1002) {
            this.$toast.text(res.body.msg);
            let _this = this;
            setTimeout(function () {
              localStorage.removeItem("userInfo");
              location.reload();
            }, 2500);
          }
        });
    },
    //验证token
    verticitionToken() {
      if (!this.userInfo.uid) {
        return false;
      }
      var time = new Date().getTime();
      var device_params = this.$store.state.deviceData;

      let data = {
        adid: this.adid,
        device_params: device_params,
        os: device_params.os,
        time: time,
        uid: this.userInfo.uid,
        token: this.userInfo.token,
      };
      let _this = this;
      this.$http.post(fun.apiUrl + "api/member/token", data).then(
        function (res) {
          if (res.body.code === 200) {
            // _this.userInfo.fcm = res.body.data.fcm;

            _this.userInfo.age = res.body.data.age;
            _this.userInfo.fcm = res.body.data.fcm;
            _this.userInfo.loginFcm = res.body.data.loginFcm;
            _this.userInfo.payFcm = res.body.data.payFcm;
            localStorage.setItem("userInfo", JSON.stringify(_this.userInfo));
          } else if (res.body.code === 1002) {
            this.$toast.text(res.body.msg);
            let _this = this;
            setTimeout(function () {
              localStorage.removeItem("userInfo");
              _this.reload();
            }, 2500);
          }
        },
        function (res) {
          this.$toast.text(res.body.msg);
        }
      );
    },
    // 检查浏览器类型
    checkedBrowserType() {
      var isSafari =
        /Safari/.test(navigator.userAgent) &&
        !/Chrome/.test(navigator.userAgent); // 是否safari浏览器
      var isWeixn = this.isWeixn(); // 是否微信
      var isIOS = this.os == "ios" ? true : false;
      if (isWeixn) {
        return;
      }
      var isDeskIcon = navigator.standalone; // 是否桌面ICON打开的
      if (isDeskIcon) {
        this.deskIcon = true;
        localStorage.setItem("deskIcon", this.deskIcon);

        if (JSON.stringify(this.userInfo) == "{}") {
          // 记录第一次从桌面图标打开，并且没有登录的，记录一次下载
          this.countDeskIconUser();
        }
        return;
      }

      // 获取URL参数
      var devType = isIOS ? 0 : 1; // 1是安卓，0是IOS

      // 请求获取游戏ICON和名称
      this.$http
        .get(fun.apiUrl + "api/game/info", {
          params: {
            adid: this.adid,
            devType: devType,
          },
        })
        .then(
          function (res) {
            var data = res.data.data;
            if (!(data instanceof Object)) return;

              if(this.ref=="iosApp"){
                data.title ="支付成功"
              }

            document.title = data.title;
            if (isSafari) {
              this.createDeskIconMeta(data.iconURL, data.title);

              this.$store.commit("postIsSafariBrowser", true);
            }
            localStorage.setItem(
              "downloadApkUrl",
              JSON.stringify(data.downloadURL)
            );
            localStorage.setItem("gameInfoDate", JSON.stringify(data));
            this.$store.commit("postVisibleGuideFloatr", true);
            this.$store.commit("postGameIconUrl", JSON.stringify(data.iconURL));
            // this.$store.commit("postGameIconUrl", data.iconURL);
          }.bind(this)
        );
    },
    // 创建苹果移动设备添加主屏的ICON和名称
    createDeskIconMeta(iconUrl, title) {
      var headEl = document.head;
      var meta = document.createElement("meta");
      meta.name = "apple-mobile-web-app-title";
      meta.content = title;
      headEl.appendChild(meta);
      var iconSizeArr = [
        "57x57",
        "72x72",
        "76x76",
        "114x114",
        "120x120",
        "144x144",
        "152x152",
      ];
      iconSizeArr.forEach(function (size) {
        var link = document.createElement("link");
        link.rel = "apple-touch-icon";
        link.sizes = size;
        link.href = iconUrl;
        headEl.appendChild(link);
      });
    },

    //  上传数据 主屏幕图标进入的用户
    countDeskIconUser() {
      // type=0 是展示，  type=1是下载  type=3  第一次从桌面ICON进入游戏
      this.$http
        .post(
          fun.apiUrl + "api/page",
          { os: this.os, pageid: this.adid, type: 3 },
          { emulateJSON: true }
        )
        .then(function (res) {});
    },

    // 上传玩家设备信息到服务器
    sendDeviceInfo() {
      var time = new Date().getTime();
      var sign = hex_md5(
        this.userInfo.uid ? this.userInfo.uid : "" + this.adid + time
      );

      // 设置uuid
      var device_params = this.$store.state.deviceData;

      let data = {
        adid: this.adid,
        sign: sign,
        time: time,
        os: device_params.os,
        uid: this.userInfo.uid,
        device_params: device_params,
      };

      this.$http.post(fun.apiUrl + "api/member/device", data).then(
        function (res) {
          if (res.body.code === 200) {
            localStorage.setItem("uuid", device_params.uuid);
          } else {
            this.$toast.text(res.body.msg);
          }
        },
        function (res) {}
      );
    },
    innerToService() {
      let roleInfo = {};
      roleInfo =
        localStorage.getItem("roleInfo") &&
        JSON.parse(localStorage.getItem("roleInfo"));
      let data = {
        adid:this.adid,
        uid: this.userInfo.uid, // 用户id
        roleID: roleInfo ? roleInfo.roleId : "", //角色id
        roleName: roleInfo ? roleInfo.roleName : "", //角色名称
        serverID: roleInfo ? roleInfo.serverId : "", //区服id
        serverName: roleInfo ? roleInfo.serverName : "",
      };
      this.$http
        .post(fun.apiUrl + "api/common/get/gameCustomerLinkUrl", data)
        .then(
          function (res) {
            if (res.data.code == 200) {
              this.$store.dispatch("IsServiceFun", true);
              this.$store.commit("postServiceUrl", res.data.data);
            } else {
              this.$toast.text(res.data.msg);
            }
          },
          function (res) {
            this.$toast.text(res.data.msg);
          }
        );
    },
  },
};
</script>
<style lang="scss" scoped>
p {
  margin: 0;
  padding: 0;
}

#inner2 {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: stretch;
}
</style>



// WEBPACK FOOTER //
// src/views/inner8.vue